export default __webpack_public_path__ + "static/media/norwaygo-screenshot-03.f4d822e8.png";